import { render } from "./TabSpiritual.vue?vue&type=template&id=39c0b48f"
import script from "./TabSpiritual.vue?vue&type=script&lang=js"
export * from "./TabSpiritual.vue?vue&type=script&lang=js"
script.render = render

export default script